import * as mainActionTypes from '../mainActionTypes';

export function setBusinessIdea(text) {
  return {
    type: mainActionTypes.SET_BUSINESS_IDEA,
    payload: { text }
  };
}

export function goToBusinessNamePage() {
  return {
    type: mainActionTypes.GO_TO_BUSINESS_NAME
  };
}

export function searchBusinessNames(businessIdea, tags, industry) {
  return {
    type: mainActionTypes.SEARCH_BUSINESS_NAMES,
    payload: {
      businessIdea,
      tags,
      industry
    }
  };
}

export function searchNamesAndIndustry(businessIdea, tags, industryID, industryValue) {
  return {
    type: mainActionTypes.SEARCH_BUSINESS_NAMES_AND_INDUSTRY,
    payload: {
      businessIdea,
      tags,
      industryID,
      industryValue
    }
  };
}
